import React from 'react';
import QuestionCard from './QuestionCard';

const FocusAreaSection = ({
  focusArea,
  responses,
  isLocked,
  highlightedQuestionId,
  onAnswerChange,
  onEvidenceChange,
  onFilesSelected,
  onRemoveBackendFile,
  onRetryPendingFile,
  onRemovePendingFile,
  darkMode,
  theme,
}) => {
  return (
    <div className="mb-6">
      <h3 className={`text-xl font-semibold p-3 rounded mb-3 border-l-4 ${darkMode ? 'bg-gray-900 border-amber-500 text-amber-300' : 'bg-amber-50 border-amber-600 text-gray-900'}`}>
        {focusArea.code && `${focusArea.code} - `}
        {focusArea.title}
      </h3>

      {(focusArea.questions || []).map((q) => {
        const current = responses.find((r) => r.question === q.id) || {
          id: null,
          answer: '',
          evidence: '',
          backendFiles: [],
          newFiles: [],
        };

        return (
          <QuestionCard
            key={q.id}
            question={q}
            response={current}
            isLocked={isLocked}
            highlighted={highlightedQuestionId === q.id}
            onAnswerChange={onAnswerChange}
            onEvidenceChange={onEvidenceChange}
            onFilesSelected={onFilesSelected}
            onRemoveBackendFile={onRemoveBackendFile}
            onRetryPendingFile={onRetryPendingFile}
            onRemovePendingFile={onRemovePendingFile}
            darkMode={darkMode}
            theme={theme}
          />
        );
      })}
    </div>
  );
};

export default FocusAreaSection;